export const helpPanelTranslations = {
    en: {
        HELP_PANEL_TITLE: 'Help',
        HELP_PANEL_TITLE_SEARCH: 'Search help',
        HELP_PANEL_NOT_FOUND: 'Articles not found, try another expression',
        SEARCH_PLACEHOLDER: 'Search'
    },
    ru: {
        HELP_PANEL_TITLE: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ°',
        HELP_PANEL_TITLE_SEARCH: 'ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ ÑÐ¿ÑÐ°Ð²ÐºÐµ',
        HELP_PANEL_NOT_FOUND: 'ÐÐ¾ Ð´Ð°Ð½Ð½Ð¾Ð¼Ñ Ð·Ð°Ð¿ÑÐ¾ÑÑ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾',
        SEARCH_PLACEHOLDER: 'ÐÐ¾Ð¸ÑÐº'
    }
};
